export enum AppTheme {
  Ayvens = 'Ayvens',
  Nordea = 'NF Fleet',
}
